const services = {
  services: 'Services',
  addServices: 'Add Services',
  editServices: 'Edit Services',
};
export default services;
